<template>
  <v-container class="pt-0 pb-0">
    <v-card-text class="pa-0">
      <v-card-title
        v-if="schemaItem.type !== global.hiddenType"
        class="subtitle-1 pr-0 pl-0 pb-0"
        >{{ itemTitle }}</v-card-title
      >
      <template v-if="schemaItem.type === global.numberType">
        <v-text-field
          type="number"
          v-model="jsonItem[itemKey]"
          min="1"
          @input="onChange"
          :rules="isHidden ? [] : [global.rules.required]"
        >
        </v-text-field>
      </template>
      <template v-if="schemaItem.type === global.inputType">
        <v-text-field
          v-model="jsonItem[itemKey]"
          :rules="isHidden ? [] : [global.rules.required]"
        >
        </v-text-field>
      </template>
      <template v-if="schemaItem.type === global.textareaType">
        <v-textarea
          name="input-7-1"
          v-model="jsonItem[itemKey]"
          rows="3"
          :rules="isHidden ? [] : [global.rules.required]"
        >
        </v-textarea>
      </template>
      <template v-if="schemaItem.type === global.htmlType">
        <vue-editor
          v-model="jsonItem[itemKey]"
          :rules="isHidden ? [] : [global.rules.required]"
        ></vue-editor>
      </template>
      <template v-if="schemaItem.type === global.checkboxType">
        <v-switch v-model="jsonItem[itemKey]"></v-switch>
      </template>
      <template v-if="schemaItem.type === global.selectType">
        <v-select
          :items="schemaItem.values"
          item-text="item"
          item-value="key"
          v-model="jsonItem[itemKey]"
          filled
          :rules="isHidden ? [] : [global.rules.required]"
        >
        </v-select>
      </template>
      <template v-if="schemaItem.type === global.imageType">
        <div class="v-picker--full-width">
          <label>
            <div id="preview">
              <img
                v-if="jsonItem[itemKey]"
                :src="global.s3Url + jsonItem[itemKey]"
                alt=""
              />
              <img v-else src="@/assets/no-photo.jpg" alt="" />
              <v-file-input
                accept="image/*"
                @change="updateImage($event)"
              ></v-file-input>
            </div>
          </label>
        </div>
      </template>
      <template v-if="schemaItem.type === global.hiddenType">
        <input
          type="hidden"
          :name="schemaItem.name"
          :value="jsonItem[itemKey]"
        />
      </template>
    </v-card-text>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { API_URL_PREFIX, GLOBAL } from "@/config/consts";
import { mapGetters } from "vuex";

export default {
  name: "Field",
  props: {
    schemaItem: {
      type: Object,
      required: true
    },
    jsonItem: {
      type: Object,
      required: true
    },
    itemKey: {
      type: String,
      required: true
    },
    landingId: {
      type: String,
      required: true
    },
    isHidden: {
      type: Boolean
    },
    itemTitle: {
      required: true
    }
  },
  data() {
    return {
      path: null,
      global: GLOBAL,
      multiLine: true,
      snackbar: false,
      errorText: "",
      overlay: false
    };
  },
  components: {
    VueEditor
  },
  computed: {
    ...mapGetters(["getErrorText"])
  },
  methods: {
    async updateImage(file) {
      if (!file) {
        return;
      }

      try {
        this.overlay = true;
        let formData = new FormData();
        formData.append(`upload_file`, file, file.name);

        const { data } = await this.$axios.post(
          `${API_URL_PREFIX}/landings/${this.landingId}/images/`,
          formData
        );

        if (data) {
          this.$set(this.jsonItem, this.itemKey, data.path);
        }
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    onChange(value) {
      if (value < 0) {
        this.$set(this.jsonItem, this.itemKey, value * -1);
      }
    }
  }
};
</script>

<style scoped>
#preview {
  width: 240px;
  height: 180px;
  border: 1px solid #eee;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}
#preview img {
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
}
</style>
<style>
#preview .v-input__prepend-outer,
#preview .v-input__slot {
  display: none;
}
#preview .v-input {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
}
#preview .v-messages__wrapper {
  text-align: center;
}
</style>
